(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-contact"] && !Shopify.designMode) return;
  try {
    
  const setupContactMaps = (root = document) => {
    root.querySelectorAll('[data-hs-map]:not([data-map-ready])').forEach((map) => {
      map.dataset.mapReady = 'true';
      const button = map.querySelector('[data-map-load]');
      const placeholder = map.querySelector('[data-map-placeholder]');
      const frame = map.querySelector('[data-map-frame]');
      if (!button || !frame) return;
      button.addEventListener('click', () => {
        const iframe = document.createElement('iframe');
        iframe.src = map.dataset.mapUrl;
        iframe.title = map.dataset.mapTitle;
        iframe.loading = 'lazy';
        iframe.referrerPolicy = 'no-referrer-when-downgrade';
        iframe.allowFullscreen = true;
        frame.appendChild(iframe);
        frame.hidden = false;
        placeholder.hidden = true;
      });
    });
  };
  setupContactMaps();
  document.addEventListener('shopify:section:load', (event) => setupContactMaps(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-tarifvergleich"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var form = root.querySelector('[data-tv-filters]');
      if (!form) return;
      var tbody = root.querySelector('tbody');
      var rows = Array.prototype.slice.call(tbody.querySelectorAll('tr'));
      var countEl = root.querySelector('[data-tv-count]');
      var emptyEl = root.querySelector('[data-tv-empty]');

      function apply() {
        var anbieter = form.anbieter ? form.anbieter.value : '';
        var netz = form.netz ? form.netz.value : '';
        var kategorie = form.kategorie ? form.kategorie.value : '';
        var zielgruppe = form.zielgruppe ? form.zielgruppe.value : '';
        var gb = parseFloat(form.gb.value) || 0;
        var preis = parseFloat(form.preis.value) || 0;
        var nur5g = form.g5 ? form.g5.checked : false;
        var sort = form.sort.value;
        var shown = 0;

        rows.sort(function (a, b) {
          if (sort === 'preis') return parseFloat(a.dataset.preis) - parseFloat(b.dataset.preis);
          if (sort === 'gb') return parseFloat(b.dataset.gb) - parseFloat(a.dataset.gb);
          return parseFloat(a.dataset.order) - parseFloat(b.dataset.order);
        });

        rows.forEach(function (row) {
          var d = row.dataset;
          var match =
            (!anbieter || d.anbieter === anbieter) &&
            (!netz || d.netz === netz) &&
            (!kategorie || d.kategorie === kategorie) &&
            (!zielgruppe || d.zielgruppe === zielgruppe) &&
            parseFloat(d.gb) >= gb &&
            (!preis || parseFloat(d.preis) <= preis) &&
            (!nur5g || d.g5 === '1');
          row.hidden = !match;
          if (match) shown++;
          tbody.appendChild(row);
        });

        if (countEl) countEl.textContent = shown;
        if (emptyEl) emptyEl.hidden = shown > 0;
      }

      var preset = new URLSearchParams(window.location.search).get('tarifart');
      if (preset && form.zielgruppe) {
        var radio = form.querySelector('input[name="zielgruppe"][value="' + (preset === 'jung' ? 'jung' : preset === 'normal' ? 'normal' : '') + '"]');
        if (radio) radio.checked = true;
      }
      form.addEventListener('change', apply);
      form.addEventListener('reset', function () { setTimeout(apply, 0); });
      apply();
    }

    document.querySelectorAll('[data-hs-tv]').forEach(init);
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-hs-tv]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
